// extracted by mini-css-extract-plugin
export default {"tabs":"M5-z","tablist":"N5-z","tablistItem":"O5-z"};